module.exports = __webpack_public_path__ + "img/396343990807392_thumbnail.jpg";